// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5":"e918c9325c59943e","410":"bc5b8c7d4575291d"}[chunkId] + ".js";
};